<template>
  <transition name="fade">
    <div
      v-if="shouldShow"
      class="absolute top-0 left-0 right-0 h-full z-40 flex items-center justify-center"
    >
      <div
        v-if="!hideBackdrop"
        class="w-full h-full bg-white opacity-75"
      />
      <fa
        :icon="['fas', 'bone']"
        class="absolute text-5xl text-indigo-600 fa-spin"
        :class="isRebranded ? 'text-ocean-950' : 'text-indigo-600'"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'VetsterPageSpinner',

  props: {
    global: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    hideBackdrop: {
      type: Boolean,
      default: false,
    },
    isRebranded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    shouldShow() {
      return this.show;
    },
  },
};
</script>
